/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
* Create a pie chart to display above a table
*/
import { AbstractChart, ChartPoint } from "@src/app/shared/chart/charts/abstract-chart";

export class PieChart extends AbstractChart {

    height = 200;
    protected showOnly = 4;

    getTooltip() {
        const format = this.formatMetric.bind(this);

        return {
            pointFormatter(this: ChartPoint) {
                return `${this.series.name}: ${format(this.y)} <br/><b>${this.percentage?.toFixed(1)}%</b>`;
            }
        };
    }

    protected createChartOptions() {

        const sglValue = this.series.length === 1;

        return {
            chart: {
                backgroundColor: this.chartBackgroundColor,
                borderRadius: this.chartBorderRadius,
                plotBorderWidth: null,
                type: 'pie',
                height: this.height,
            },
            title: this.getChartTitle(),
            subtitle: this.getSubTitle(),
            credits: { enabled: false },
            tooltip: this.getTooltip(),
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    events: {
                        click: this.filterData.bind(this)
                    },
                    dataLabels: {
                        enabled: true,
                        format: sglValue ? '{point.name}<br/>{point.y:,.0f}' : '{point.name}',
                        style: sglValue ? { fontSize: 14, textAlign: 'center' } : {},
                        distance: sglValue ? -70 : 0,
                        useHTML: true,
                    }
                }
            },
            series: [{
                name: this.getSeriesName(),
                colorByPoint: true,
                data: this.series
            }]
        }
    }
}
